// extracted by mini-css-extract-plugin
export default {"container":"login-callback_container__G7ift","wrapper":"login-callback_wrapper__gTrrw","icon":"login-callback_icon__S6-Cl","text":"login-callback_text__8v3Fj"};